import Vuex from 'vuex'
import Vue from 'vue';

Vue.use(Vuex)
var gaussian = require('gaussian');



function arraysEqual(a1,a2) {
  return JSON.stringify(a1)==JSON.stringify(a2);
}


function arrayMatch(a1,arrayset) {
  var returnvar = false;
  for(let a=0; a<arrayset.length; a++){
    //console.log("a1",a1,"a2",arrayset[a])
    if(arraysEqual(a1,arrayset[a])){
      returnvar = true
    }else{

    }
  }
  return returnvar;


}

function findDateIndex(DateIndex,DateToFind) {

  var index = DateIndex.findIndex((v) => {
    return new Date(v).getTime()===new Date(DateToFind).getTime();
  });

    return index;
}

function getDateIndex(timelinezoomlevel,x,statein) {
  if(timelinezoomlevel=="days"){
    var dateIndex = JSON.parse(JSON.stringify(statein.DateIndex));

  }else{
    var dateIndex = JSON.parse(JSON.stringify(statein.MonthIndex));

  }
  var xDate=new Date(x)
  if(xDate instanceof Date && !isNaN(xDate)){
    console.log("x is a Date",xDate)
    var startDate =xDate

  }else{
    console.log("x is not a Date",x)
    var startDate =new Date(x.year,(x.month),x.day)

  }
  //console.log("getDateIndex startDate",startDate)
  var foundIndex = findDateIndex(dateIndex,startDate)

  return foundIndex
}

function getNewDate(timelinezoomlevel,x,statein) {
  if(timelinezoomlevel=="days"){
    var dateIndex = JSON.parse(JSON.stringify(statein.DateIndex));

  }else{
    var dateIndex = JSON.parse(JSON.stringify(statein.MonthIndex));

  }

  var newDate = new Date(dateIndex[x])
  //console.log("newDate",newDate,"dateIndex[x]",dateIndex[x],"x",x)
  return [{year:newDate.getFullYear(),month:newDate.getMonth()+1,day:newDate.getDate()}][0]


}


function combineTimeSeries(timeSeries,methods,timelinezoomlevel,statein) {
console.log("----combineTimeSeries",timeSeries,methods,timelinezoomlevel)
  if(timelinezoomlevel=="days"){
    var dateIndex = JSON.parse(JSON.stringify(statein.DateIndex));

  }else{
    var dateIndex = JSON.parse(JSON.stringify(statein.MonthIndex));

  }
  //      output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]},

  var base={time:[],value:[]}
  console.log("----base",base)

   for(let i=0; i<dateIndex.length; i++){
     //console.log("i",i,dateIndex[i])
     base.time.push(dateIndex[i])
     base.value.push(0)

   }
   console.log("----base",base)
   var output = JSON.parse(JSON.stringify(base))

  for(let ts=0; ts<timeSeries.length; ts++){
    console.log("----t",ts)
    console.log("timeSeries",timeSeries[ts])
    //always continuous run from start to end of array for each ts
    let startDate = timeSeries[ts].time[0]
    //find index on Base




    let startIndex = getDateIndex(timelinezoomlevel,startDate,statein)


    let endDate = timeSeries[ts].time[timeSeries[ts].time.length-1]
    //find index on Base
    let endIndex = getDateIndex(timelinezoomlevel,endDate,statein)
    console.log("startIndex",startIndex)
    console.log("endIndex",endIndex)



    for(let t=startIndex; t<(endIndex+1); t++){

      //combine
      timeSeries[ts].time[t-startIndex]
      output.value[t]=output.value[t] + timeSeries[ts].value[t-startIndex]

    }

  }
  console.log("combineTimeSeries output",output)
  return output;

}


export const store = new Vuex.Store({
  state: {
    count: 0,
    allGroups: true,
    showCharts: false,
    startyear: 2017,
    endyear: 2025,
    forecastDateRange: [{year:2020,month:4,day:1},{year:2028,month:12,day:31}],
    years:7,
    months:72,
    days:500,
    MonthIndex:[],
    colWidth: 50,
    rowHeight: 15,
    DateIndex: [],
    BlockLevelSelected: [],
    CanvasActiveTree: [],
    VDRpreventActiveBehavior: false,
    ScenarioSets:[
      {
        id: [1],
        mode: "model",
        name: "Model 1!",
        CanvasGroups: [1,2],
        CloneCanvasGroups: [1,2],
        UseCloneCanvasGroup: [false,false]

      },
      {
        id: [2],
        mode: "model",
        name: "Model 2!",
        CanvasGroups: [2],
        CloneCanvasGroups: [2],
        UseCloneCanvasGroup: [false]
      },
      {
        id: [3],
        mode: "scenario",
        name: "Scenario 1!",
        sets:[
          {
            id:1,
            name:"Set 1",
            subsets:[
              {
                id:1,
                name: "Demand",
                type: "Models",
                CanvasGroups:[1,2]
              },{
                id:2,
                name: "Supply",
                type: "Models",
                CanvasGroups:[1,2]
              },{
                id:3,
                name: "Price",
                type: "Models",
                CanvasGroups:[1,2]
              },{
                id:3,
                name: "Revenue",
                type: "Models",
                CanvasGroups:[3]
              },
              {
                id:4,
                name: "Revenue",
                type: "Computed",
                CompComponents : [
                  {name:"Computed Revenue 1",CanvasGroups:[1,2], methods:["*"]}
                ],
                CompFunction :["*"],
                CanvasGroups:[1,2]

              }
            ]
          },
          {
            id:2,
            name:"Set 2",
            subsets:[
              {
                id:1,
                name: "Demand",
                type: "Models",
                CanvasGroups:[2]
              },{
                id:2,
                name: "Supply",
                type: "Models",
                CanvasGroups:[2]
              },{
                id:3,
                name: "Price",
                type: "Models",
                CanvasGroups:[2]
              }
            ]
          }
        ],
        setsData:[
          {
          id:1,
          name:"Demand",
          CanvasGroups:[[1,2],[1]]
          },
          {
          id:2,
          name:"Supply",
          CanvasGroups:[[1,2],[1]]
          },
          {
          id:3,
          name:"Price",
          CanvasGroups:[[1,2],[1]]
          },
          {
          id:4,
          name:"Revenue",
          CanvasGroups:[[3]]
          }
        ],
        CanvasGroups: [2],
        CloneCanvasGroups: [2],
        UseCloneCanvasGroup: [false]
      }
    ],
    CanvasGroups:[
      {
      id:[1],
      core:true,
      coreid:[1],
      cloneid:[1],
      name: "I am Historical data and layers",
      combination: false,
      serviceids:[1,2],
      custSegids:[1,2],
      productids:[1,2],
      groupids:[[1,1,1],[2,2,2]],
      top:0,
      selected:false,
      data:[],
      params:[],
      output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]},
      childselected:false,
      daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
      x:0,
      y:0,
      w:1000,
      h:500,
      status:2,
      children:[
        {
          id:[1,1],
          name: "I am Block 1",
          combination: false,
          groupid:[1,1,1],
          daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
          x:0,
          y:50,
          w:1000,
          h:250,
          selected:false,
          data:[],
          params:[],
          output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]},
          childselected:false,
          status:2,
          children:[
            {
              id:[1,1,1],
              name: "long run",
              combination: false,
              type:1,
              status:2,
              daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
              x:0,
              y:0,
              w:1000,
              h:75,
              rows:12,
              children:[
                {
                id: [1,1,1,1],
                name:"I am subcomponent 1",
                combination: false,
                status:1,
                daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
                x:0,
                y:0,
                w:1000,
                h:75,
                rows:8,
                selected:false,
                data:[],
                params:[],
                output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]}
              },
              {
                id: [1,1,1,2],
                name:"I am subcomponent 2",
                combination: false,
                status:2,
                daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
                x:0,
                y:0,
                w:1000,
                h:75,
                rows:8,
                selected:false,
                data:[],
                params:[],
                output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]}
            }
              ],
              selected:false,
              childselected:false,
              data:[],
              params:[],
              output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]}
            }
          ]
        }

      ]



      },

      {
      id:[2],
      core:true,
      coreid:[1],
      cloneid:[1],
      name: "I am Historical data and layers 2",
      combination: false,
      serviceids:[1,2],
      custSegids:[1,2],
      productids:[1,2],
      groupids:[[1,1,1],[2,2,2]],
      top:0,
      height:300,
      selected:false,
      data:[],
      params:[],
      output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]},
      childselected:false,
      daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
      x:0,
      y:0,
      w:1000,
      h:500,
      status:2,
      children:[]
    },

    {
      id:[3],
      core:true,
      coreid:[1],
      cloneid:[1],
      name: "Revenue 1",
      combination: true,
      serviceids:[1,2],
      custSegids:[1,2],
      productids:[1,2],
      groupids:[[1,1,1],[2,2,2]],
      top:0,
      height:300,
      selected:false,
      data:[],
      params:[],
      output:{time:[{year:2019,month:1,day:1},{year:2019,month:2,day:1}], value:[1,2]},
      childselected:false,
      daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
      x:0,
      y:0,
      w:1000,
      h:500,
      status:2,
      children:[]
    }

    ],

    DataSets:[
      {
        id:1,
        serviceid:1,
        custSegid:1,
        productid:1,
        historicalData:[],
        TScomponents:[
          {
            id:1,
            type:1,
            data:[],
            params:[]
          },
          {
            id:2,
            type:2,
            data:[],
            params:[]
          },
          {
            id:3,
            type:3,
            data:[],
            params:[]
          },
          {
            id:4,
            type:4,
            data:[],
            params:[]
          },
          {
            id:5,
            type:5,
            data:[],
            params:[]
          }
        ]
      },
      {
        id:2,
        serviceid:2,
        custSegid:2,
        productid:2,
        historicalData:[],
        TScomponents:[
          {
            id:1,
            type:1,
            data:[],
            params:[]
          },
          {
            id:2,
            type:2,
            data:[],
            params:[]
          },
          {
            id:3,
            type:3,
            data:[],
            params:[]
          },
          {
            id:4,
            type:4,
            data:[],
            params:[]
          },
          {
            id:5,
            type:5,
            data:[],
            params:[]
          }
        ]
      }
    ],
    CurrentScenario: [1],
    ScenarioGroups: [{
      id: 1,
      name: "40 Year Outlook",
      scenarios: [1]
    }],
    Scenarios: [{
        id: 1,
        name: "My first Scenario!",

        demand: [{
          selected: [1]
        }],
        price: [{
          selected: [2]
        }],
        supply:[{
          selected: []
        }]
      }
    ],
    TimelineGroups: [{
        id:1,
        name:"Group 1",
        types:[1],
        start: 1,
        end: 4,
        subGroups: [1],
        options:[],
        output: [],
        Stochasticoutput: []
      },
      {
        id:2,
        name:"Test Group 2",
        types:[2],
        start: 8,
        end: 20,
        subGroups: [2],
        options:[],
        output: [],
        Stochasticoutput: []
      }
    ],
    TimelineSubGroups: [{
        id:1,
        name:"Sub Group 1",
        start: 1,
        end: 2,
        options:[],
        output: [],
        Stochasticoutput: [],
        services:[121],
        customerSements:[111,211]
      },
      {
        id:2,
        name:"Sub Group 2",
        start: 1,
        end: 2,
        options:[],
        output: [],
        Stochasticoutput: [],
        services:[212],
        customerSements:[111]
      }
    ],
    TimelineSubGroupsOutput: [{
        id:1,
        output: []
      },
      {
        id:2,
        output: []
      }
    ],
    buildingblockProperties:[
      {
      type:1,
      activeeditsize:1,
      subtypes:[{
          type:"simple",
          activeeditsize:2
        },
        {
          type:"complex",
          activeeditsize:2
        }]
      },
      {
      type:2,
      activeeditsize:1,
      subtypes:[{
          type:"simple",
          activeeditsize:2
        },
        {
          type:"complex",
          activeeditsize:2
        }]
      },
      {
      type:3,
      activeeditsize:1,
      subtypes:[{
          type:"single",
          activeeditsize:2
        },
        {
          type:"multi",
          activeeditsize:4
        }]
      },
      {
      type:4,
      activeeditsize:1,
      subtypes:[{
          type:"trigonometric",
          activeeditsize:4
        },
        {
          type:"Custom",
          activeeditsize:4
        }]
      },
      {
      type:5,
      activeeditsize:1,
      subtypes:[{
          type:"uniform",
          activeeditsize:4
        },
        {
          type:"variable",
          activeeditsize:4
        }]
      }
  ],
    RowBlocks: [{
        id: [1,1,1,1,1,1],
        name: 'Super Block',
        rank:0,
        start:1,
        end:75,
        type:1,
        data:[
          {x:1,y:4},
          {x:2,y:3},
          {x:3,y:9}

        ],
        chartdata:[1,2,3],
        activeedit: true,
        buildingblocks:[{
          rank:1,
          start:5,
          end:70,
          type:1,
          linktype:1,
          params:[0],
          Stochasticparams:[0],
          activeeditsize: 1,
          activeedit: true
        }]
      }
      ,
      {
          id: [1,2,1,1,1,1],
          name: 'Super Block 2',
          rank:0,
          start:1,
          end:75,
          type:2,
          data:[
            {x:1,y:4},
            {x:2,y:3},
            {x:3,y:9}

          ],
          chartdata:[1,2,3],
          activeedit: true,
          buildingblocks:[{
            rank:1,
            start:5,
            end:70,
            type:1,
            linktype:1,
            params:[0],
            Stochasticparams:[0],
            activeeditsize: 1,
            activeedit: true
          }]
      }
      ,
      {
          id: [2,1,1,1,1,1],
          name: 'Super Block 3',
          rank:0,
          start:1,
          end:75,
          type:3,
          data:[
            {x:1,y:4},
            {x:2,y:3},
            {x:3,y:9}

          ],
          chartdata:[1,2,3],
          activeedit: true,
          buildingblocks:[{
            rank:1,
            start:5,
            end:70,
            type:1,
            linktype:1,
            params:[0],
            Stochasticparams:[0],
            activeeditsize: 2,
            activeedit: true
          },
          {
            rank:2,
            start:5,
            end:70,
            type:1,
            linktype:1,
            params:[0],
            Stochasticparams:[0],
            activeeditsize: 2,
            activeedit: true
          }]
        }
        ,
        {
            id: [2,2,1,1,1,1],
            name: 'Super Block 4',
            rank:0,
            start:1,
            end:75,
            type:4,
            data:[
              {x:1,y:4},
              {x:2,y:3},
              {x:3,y:9}

            ],
            chartdata:[1,2,3],
            activeedit: true,
            buildingblocks:[{
              rank:1,
              start:5,
              end:70,
              type:1,
              linktype:1,
              params:[0],
              Stochasticparams:[0],
              activeeditsize: 1,
              activeedit: true
            }]
          }
          ,
          {
              id: [2,2,2,1,1,1],
              name: 'Super Block 5',
              rank:0,
              start:1,
              end:75,
              type:5,
              data:[
                {x:1,y:4},
                {x:2,y:3},
                {x:3,y:9}

              ],
              chartdata:[1,2,3],
              activeedit: false,
              buildingblocks:[{
                rank:1,
                start:5,
                end:70,
                type:1,
                linktype:1,
                params:[0],
                Stochasticparams:[0],
                activeeditsize: 1,
                activeedit: true
              }]
            }
    ],
    outputBlocks:[],
    CustomerSegmentsTree: [{
      id: 1,
      label: 'Passengers',
      children: [{
        id: 11,
        label: 'Cash',
        children: [{
          id: 111,
          label: 'Base'
        }, {
          id: 112,
          label: 'Concession'
        }]
      },{
        id: 12,
        label: 'Commuter',
        children: [{
          id: 121,
          label: 'Monthly Pass'
        }, {
          id: 122,
          label: 'Employee Pass'
        }]
      }
    ]
    }, {
      id: 2,
      label: 'Vehicles',
      children: [{
        id: 21,
        label: 'Private Vehicle',
        children: [{
          id: 211,
          label: '20ft and Under'
        },{
          id: 212,
          label: 'Over 20ft'
        }]
      }, {
        id: 22,
        label: 'Commercial Vehicle',
        children: [{
          id: 221,
          label: 'Under 30 ft'
        },{
          id: 222,
          label: '30ft and over'
        }]
      }]
    }],
    ServiceTree: [{
      id: 1,
      label: 'Rail',
      children: [{
        id: 11,
        label: 'Subway',
        children: [{
          id: 111,
          label: 'East Line'
        }, {
          id: 112,
          label: 'West Line'
        }]
      },{
        id: 12,
        label: 'LRT',
        children: [{
          id: 121,
          label: 'Shore Line'
        }, {
          id: 122,
          label: 'Stadium Line'
        }]
      }
    ]
    }, {
      id: 2,
      label: 'Bus',
      children: [{
        id: 21,
        label: 'Rapid Bus',
        children: [{
          id: 211,
          label: 'R-55'
        },{
          id: 212,
          label: 'R-65'
        }]
      }, {
        id: 22,
        label: 'Conventional',
        children: [{
          id: 221,
          label: 'R-10'
        },{
          id: 222,
          label: 'R-20'
        },{
          id: 223,
          label: 'R-30'
        },{
          id: 224,
          label: 'R-40'
        },{
          id: 225,
          label: 'R-50'
        }]
      }]
    }, {
      id: 3,
      label: 'Ferry',
      children: [{
        id: 31,
        label: 'SeaBus'
      }, {
        id: 32,
        label: 'Driftwood Island'
      }]
    }]
  },
  mutations: {
    UpdateACanvasDateRange (state, payload) {
      console.log("UpdateACanvasDateRange",payload)

      var clone = JSON.parse(JSON.stringify(state.CanvasGroups));
      var id = payload[0]
      var x1 = new Date(payload[1])
      var x2 = new Date(payload[2])

      console.log("Store x1:",x1,"x2",x2)

      if (id.length==1){
        var index0 = clone.findIndex((v) => {
          return v.id==id[0];
        });


        state.CanvasGroups[index0].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                              {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

      }else if (id.length==2) {


          var index0 = clone.findIndex((v) => {
            return v.id==id[0];
          });

          var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
          var index1 = clone2.findIndex((v) => {
            return v.id==id[1];
          });

          state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

          //check parent size
          var psdr = state.CanvasGroups[index0].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }
      }else if(id.length==3){


          var index0 = clone.findIndex((v) => {
            return v.id==id[0];
          });

          var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
          var index1 = clone2.findIndex((v) => {
            return v.id==id[1];
          });

          var clone3=JSON.parse(JSON.stringify(clone2[index1].TScomponents))
          var index2 = clone3.findIndex((v) => {
            return v.id==id[2];
          });

          state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

          //check parent size
          var psdr = state.CanvasGroups[index0].Blocks[index1].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }

          //check grandparent size
          var psdr = state.CanvasGroups[index0].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }

      }else if(id.length==4){


          var index0 = clone.findIndex((v) => {
            return v.id==id[0];
          });

          var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
          var index1 = clone2.findIndex((v) => {
            return v.id==id[1];
          });

          var clone3=JSON.parse(JSON.stringify(clone2[index1].TScomponents))
          var index2 = clone3.findIndex((v) => {
            return v.id==id[2];
          });

          var clone4=JSON.parse(JSON.stringify(clone2[index1].TScomponents[index2].subcomponents))
          var index3 = clone4.findIndex((v) => {
            return v.id==id[3];
          });

          state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].subcomponents[index3].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

          //check parent size
          var psdr = state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }

          //check grandparent size
          var psdr = state.CanvasGroups[index0].Blocks[index1].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }


          //check greatgrandparent size
          var psdr = state.CanvasGroups[index0].daterange
          var parentstartdate = new Date(psdr[0].year,psdr[0].month,psdr[1].day)
          var parentenddate = new Date(psdr[1].year,psdr[1].month,psdr[1].day)


          if(parentstartdate>x1){
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }else{

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:x1.getFullYear(),month:x1.getMonth(),day:x1.getDate()},
                                                    {year:parentenddate.getFullYear(),month:parentenddate.getMonth(),day:parentenddate.getDate()}]

            }
          }else{
            if(parentenddate<x2){

              state.CanvasGroups[index0].Blocks[index1].daterange=[{year:parentstartdate.getFullYear(),month:parentstartdate.getMonth(),day:parentstartdate.getDate()},
                                                    {year:x2.getFullYear(),month:x2.getMonth(),day:x2.getDate()}]

            }

          }

      }
    },

    UpdatecolWidth (state, payload) {
      console.log("UpdatecolWidth",payload)
      state.colWidth=payload[0]
      // state.years=payload[1]
      // state.months=payload[2]
      // state.days=payload[3]

    },
    BuildActiveTree (state, payload) {
      console.log("BuildActiveTree")
      state.CanvasActiveTree=state.CanvasGroups
    },
    SetActiveCanvasBlock (state, payload) {

      console.log("SetActiveCanvasBlock",payload)
      //console.log("hi")
      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))
      //console.log("clone",clone)

      function arraysEqual(a1,a2) {
        return JSON.stringify(a1)==JSON.stringify(a2);
      }

      function childselected(blocks) {
        //check if their are children
        var cselected = false
        console.log("children blocks.length",blocks.length,blocks)


        for(let c=0; c<blocks.length; c++){
          console.log("c",c,"name",blocks[c].name,"selected",blocks[c].selected)

          if(blocks[c].selected==true){

            console.log("child was selected")
            cselected = true;

          }else{
            //check if any of the children's children are selected
            console.log("child was not selected")

            if(blocks[c].hasOwnProperty("children")){
              //for each child, check if any of them are selected
              cselected=childselected(blocks[c].children)



            }else{
              //no children, so no selected child
            }


          }

        }

      return cselected;






      }



      function allBlocksDeselected(id,blocks) {
        console.log("blocks",blocks,"id",id,"blocks length",blocks.length)
        // for(let b=0; b<blocks.length; b++) {
        //   console.log("b",b)}
        for(let b=0; b<blocks.length; b++) {
          console.log("b",b)


          if(blocks[b].hasOwnProperty("children")){
            console.log("was my child selected?",childselected(blocks[b]))
            console.log("I have children")
            if(arraysEqual(blocks[b].id,id)){

              // if(childselected(blocks[b].children)){
              //   //console.log("was my child was selected",childselected(blocks[b]))
              //   blocks[b].selected=false
              //
              // }else{
              //
              //   blocks[b].selected=true
              //
              // }

              blocks[b].selected=true


            }else{

              blocks[b].selected=false

            }

            blocks[b].children = allBlocksDeselected(id,blocks[b].children)

          }else{
            if(arraysEqual(blocks[b].id,id)){

              blocks[b].selected=true
            }else{

              blocks[b].selected=false

            }
            return blocks[b]

          }
        }
        return blocks;
      }



      console.log("-------------------------------------------------------payload",payload,"clone",clone)
      console.log("allBlocksDeselected",allBlocksDeselected(payload,clone))
      //state.CanvasGroups=allBlocksDeselected(payload,clone)

    },

    DeactivateCanvasGroupElement (state, payload) {
      console.log("DeactivateCanvasGroupElement",payload)
      var clone=JSON.parse(JSON.stringify(state.CanvasActiveTree))


      console.log(clone)
      if(payload.length==3){
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
        var index1 = clone2.findIndex((v) => {
          return v.id==payload[1];
        });

        var clone3=JSON.parse(JSON.stringify(clone2[index1].TScomponents))
        var index2 = clone3.findIndex((v) => {
          return v.id==payload[2];
        });

        state.CanvasActiveTree[index0].Blocks[index1].childselected=false


      }else if (payload.length==2) {
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
        var index1 = clone2.findIndex((v) => {
          return v.id==payload[1];
        });
        state.CanvasActiveTree[index0].childselected=false


      }else if (payload.length==1) {
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });

      }



    },
    UpdateCanvasGroupActiveLevels (state, payload) {
      console.log("UpdateCanvasGroupActiveLevels",payload)


      //clear all selected
      var clone=JSON.parse(JSON.stringify(state.CanvasActiveTree))






      console.log(clone)
      if(payload.length==3){

        console.log("payload length 3")

        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
        var index1 = clone2.findIndex((v) => {
          return v.id==payload[1];
        });

        var clone3=JSON.parse(JSON.stringify(clone2[index1].TScomponents))
        var index2 = clone3.findIndex((v) => {
          return v.id==payload[2];
        });

        for(let c=0; c<clone.length; c++){

          clone[c].selected=false;

          for(let b=0; b<clone[c].Blocks.length; b++){

            clone[c].Blocks[b].selected=false

            for(let t=0; t<clone[c].Blocks[b].TScomponents.length; t++){

              clone[c].Blocks[b].TScomponents[t].selected=false

            }

          }

        }

        clone[index0].selected=false;
        clone[index0].childselected=true;

        clone[index0].Blocks[index1].selected=false;
        clone[index0].Blocks[index1].childselected=true;

        clone[index0].Blocks[index1].TScomponents[index2].selected=true;


      }else if (payload.length==2) {
        console.log("payload length 2")
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        var clone2=JSON.parse(JSON.stringify(clone[index0].Blocks))
        var index1 = clone2.findIndex((v) => {
          return v.id==payload[1];
        });
        //if childselected, do nothing
        if(clone[index0].Blocks[index1].childselected==true){
          console.log("child selected, do nothing")


        }else{





          for(let c=0; c<clone.length; c++){

            clone[c].selected=false;

            for(let b=0; b<clone[c].Blocks.length; b++){

              clone[c].Blocks[b].selected=false

              for(let t=0; t<clone[c].Blocks[b].TScomponents.length; t++){

                clone[c].Blocks[b].TScomponents[t].selected=false

              }

            }

          }
          clone[index0].selected=false;
          clone[index0].childselected=true;

          clone[index0].Blocks[index1].selected=true;

        }
      }else if(payload.length==1){
        console.log("payload length 1")

        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });

        //if childselected, do nothing
        if(clone[index0].childselected==true){
          console.log("child selected, do nothing")

        }else{

          for(let c=0; c<clone.length; c++){

            clone[c].selected=false;

            for(let b=0; b<clone[c].Blocks.length; b++){

              clone[c].Blocks[b].selected=false

              for(let t=0; t<clone[c].Blocks[b].TScomponents.length; t++){

                clone[c].Blocks[b].TScomponents[t].selected=false

              }

            }

          }
          clone[index0].selected=true;


        }
      }

      state.CanvasActiveTree=clone

    },
    UpdateCanvasGroupCoreLinks(state,payload){
      console.log("UpdateCanvasGroupCoreLinks",payload)

      if(payload[1]=true){
        //make clone
        var clone=JSON.parse(JSON.stringify(state.CanvasGroups))

        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });

        var newCanvasGroup = clone[index0]

        //set to clone

      }else{
        //return to core
      }


    },
    UpdateCanvasGroupParam(state,payload){
      console.log("UpdateCanvasGroupParam",payload)
      var updates = payload[1]

      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))

      function updateTree(id, tree) {
        if(arraysEqual(tree.id,id)){
          console.log("-- id is a match, updating")

          for(let u=0; u<updates.length; u++){
            tree[updates[u][0]]=updates[u][1]
          }

          return tree
        }else{
        }

        if(tree.hasOwnProperty("children")){
          for(let c=0; c<tree.children.length; c++){
            tree.children[c]=updateTree(id, tree.children[c])
          }
        }
        return tree
      }

      for(let cg=0; cg<clone.length; cg++){
        console.log("cg",cg)
        console.log("clone[cg]",clone[cg])
        clone[cg]=updateTree(payload[0], clone[cg])

      }
      console.log("UpdateCanvasGroupParam",clone)
      state.CanvasGroups=clone



    },
    DeactivateAllOtherVDRInstances(state,payload){
      console.log("DeactivateAllOtherVDRInstances",payload)

      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))

      function updateTree(id, update, tree) {
        if(arraysEqual(tree.id,id)){
          console.log("-- id is a match, updating")
          tree.active=update
        }else{
          tree.active=!update
        }

        if(tree.hasOwnProperty("children")){
          for(let c=0; c<tree.children.length; c++){
            tree.children[c]=updateTree(id, update, tree.children[c])
          }
        }
        return tree
      }

      for(let cg=0; cg<clone.length; cg++){
        console.log("cg",cg)
        console.log("clone[cg]",clone[cg])
        clone[cg]=updateTree(payload, true, clone[cg])

      }
      console.log("DeactivateAllOtherVDRInstances output",clone)
      state.CanvasGroups=clone
    },

    UpdateOmniBlockDimensions(state, payload){

      console.log("UpdateOmniBlockDimensions",payload)

      var idin = payload[0]
      var timelinezoomlevel = payload[1]
      var xin = payload[2]
      var win = payload[3]
      var yin = payload[4]
      var hin = payload[5]
      var newxdate=payload[6]
      var newx2date=payload[7]


      var updateset = [xin,win,yin,hin,newxdate,newx2date]

      var idchain = []
      console.log("idin",idin)
      for(let idlevel=0; idlevel<idin.length; idlevel++){
        var temp = []
        for(let t=0; t<(idlevel+1); t++){
          temp.push(idin[t])
        }
      idchain.push(temp)

      }
      //console.log("idchain",idchain)
      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))
      var clone2=JSON.parse(JSON.stringify(state.CanvasGroups))

      function updateTree(id,idchainin, update, tree) {
        console.log("-----------tree in", tree.name, "id", tree.id,"idchainin",idchainin,"idin",idin)

        //probably need a for loop here to make sure all branches checked
          if (arrayMatch(tree.id,idchainin)) {
              console.log("arrayMatch found")
              if(arraysEqual(tree.id,id)){
                console.log("-- id is a match, updating")
                //tree.x = update[0]
                //console.log("current date", tree.daterange[0],"new date", getNewDate(timelinezoomlevel,update[0],state))
                //tree.daterange[0]=getNewDate(timelinezoomlevel,update[0],state)
                tree.daterange[0]=newxdate
                console.log("xupdate",tree.name,newxdate)
                tree.daterange[1]=getNewDate(timelinezoomlevel,update[0]+update[1],state)

                // tree.w = update[1]
                // tree.y = update[2]
                // tree.h = update[3]

              }else{
                console.log("-- id is not a match, check parent size reflects updated child")
                //check x (left) compliance
                var xref = getDateIndex(timelinezoomlevel,tree.daterange[0],state)
                console.log("xref",xref,"update[0]",update[0])
                if(xref>update[0]){
                  console.log("parent x1 needs to shift left")
                  //tree.x=update[0]
                  //console.log("getNewDate",getNewDate(timelinezoomlevel,update[0],state))
                  //tree.daterange[0]=getNewDate(timelinezoomlevel,update[0],state)
                  //tree.daterange[0]=getNewDate(timelinezoomlevel,update[0],state)
                  tree.daterange[0]=newxdate
                  console.log("xupdate",tree.name)

                }
                //check x (right) compliance
                var xref = getDateIndex(timelinezoomlevel,tree.daterange[1],state)

                if((xref)<(update[0]+update[1])){
                  console.log("parent x2 needs to shift right")

                  //tree.w = update[1]
                  tree.daterange[1]=newx2date

                  //tree.daterange[1]=getNewDate(timelinezoomlevel,update[0]+update[1],state)

                }
              }


          } else {
              console.log("arrayMatch not found")


          }
          //console.log("tree",tree)
          if(tree.hasOwnProperty("children")){
            console.log("checking children")
            for (let c=0; c<tree.children.length; c++) {
              var updatedchild=updateTree(idin, idchainin, update, tree.children[c])
              //console.log(tree.name,"updatedchild",updatedchild)
              //console.log("replacing",tree.children[c])
              tree.children[c]=updatedchild
            }
            return tree;
          }else{
            //console.log("no children",tree)
            return tree;

          }
      }

      //starting at the top of the Canvas Tree, make sure each parent is compliant with the size of its children

      //console.log("updateTree",updateTree(idin,idchain, updateset, clone[0]))
      clone[0]=updateTree(idin,idchain, updateset, clone[0])
      console.log("start tree",clone2)
      console.log("returned tree",clone)

      state.CanvasGroups=clone
    },
    AddChildBlock (state, payload) {
      console.log("AddChildBlock in store", payload)

      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))

      function findBlock(id,tree,child) {
        console.log("findBlock",tree.id,id)
        var idcopy = JSON.parse(JSON.stringify(id))
        if(arraysEqual(id,tree.id)){
          console.log("findBlock id found",tree)
          //add block
          if(tree.hasOwnProperty("children")){

            if(tree.children.length<1){
              idcopy.push(1)
              console.log("newid",newid)
              tree.children=[
                  {
                  id: idcopy,
                  name:child.name,
                  type:child.type[0],
                  status:2,
                  serviceids:[1,2],
                  custSegids:[1,2],
                  productids:[1,2],
                  daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
                  x:0,
                  y:0,
                  w:1000,
                  h:75,
                  rows:8,
                  selected:false
                }
              ]
              console.log("first", tree.children)
            }else{
              var newChild=JSON.parse(JSON.stringify(tree.children[tree.children.length-1]))
              var newid = JSON.parse(JSON.stringify(newChild.id))
              newid[newid.length-1] = newid[newid.length-1]+1

              console.log("newid",newChild.id,newid)
              newChild.id=JSON.parse(JSON.stringify(newid))
              newChild.name=child.name
              newChild.status=2
              newChild.children=[]
              newChild.type=child.type[0]
              tree.children.push(newChild)
            }


          }else{
            console.log("starting child")
            tree.children=[
                {
                id: id.push(1),
                name:child.name,
                type:child.type[0],
                status:2,
                serviceids:[1,2],
                custSegids:[1,2],
                productids:[1,2],
                daterange:[{year:2018,month:1,day:1},{year:2020,month:4,day:1}],
                x:0,
                y:0,
                w:1000,
                h:75,
                rows:8,
                selected:false
              }
            ]
          }




        }else{
          if(tree.hasOwnProperty("children")){
            for (let c=0; c<tree.children.length; c++) {
              tree.children[c]=findBlock(id,tree.children[c],child)
            }
          }
        }

        return tree
      }

      //search for id

      for(let r=0; r<clone.length; r++){
        console.log("r",r)
        clone[r]=findBlock(payload[0],clone[r],payload[1])

      }

      state.CanvasGroups=clone



    },
    VDRpreventActiveBehavior (state, payload) {
      state.VDRpreventActiveBehavior=!state.VDRpreventActiveBehavior
      console.log("VDRpreventActiveBehavior",state.VDRpreventActiveBehavior)
    },
    ExpandOmniBlock (state, payload) {
      console.log("ExpandOmniBlock in store",payload)
      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))
      console.log("update id",payload[0])
      console.log("current status",payload[1])

      if(payload[1]==2){
        var newstatus = 1
      }else{
        var newstatus = 2
      }

      if(payload.length>2){
          var setallchildren=true
      }else{
          var setallchildren=false

      }
      console.log("newstatus",newstatus)

      function updateTree(id,status,tree,setallchildren){

        if(arraysEqual(tree.id,id)){
          console.log("id a match")
          tree.status=status
          if(tree.hasOwnProperty("children")){
            for (let c=0; c<tree.children.length; c++) {
              tree.children[c]=updateTree(id, status, tree.children[c],true)
            }
          }
        }else if(setallchildren){
          console.log("setallchildren")

          if(newstatus==2){
            var childstatus=2
          }else{
            var childstatus=0
          }
          tree.status=childstatus
          if(tree.hasOwnProperty("children")){
            for (let c=0; c<tree.children.length; c++) {
              tree.children[c]=updateTree(id, childstatus, tree.children[c],true)
            }
          }
        }else{
          if(tree.hasOwnProperty("children")){
            console.log("id not a match")

            for (let c=0; c<tree.children.length; c++) {
              tree.children[c]=updateTree(id, status, tree.children[c],setallchildren)
            }
          }
        }

        return tree
      }

      for(let l=0; l<clone.length; l++){
        clone[l]=updateTree(payload[0],newstatus,clone[l],false)
      }

      state.CanvasGroups=clone
      console.log("ExpandOmniBlock state.CanvasGroups",state.CanvasGroups)
    },

    UpdateCanvasGroup (state, payload) {
      console.log("UpdateCanvasGroup",payload)
      var clone=JSON.parse(JSON.stringify(state.CanvasGroups))
      console.log("clone",clone)

      if(payload.length==3){
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        console.log("index0", index0)
        var index1 = clone[index0].Blocks.findIndex((v) => {
          return v.id==payload[1];
        });
        var index2 = clone[index0].Blocks[index1].TScomponents.findIndex((v) => {
          return v.id==payload[2];
        });
        console.log("these are the indicies",index0,index1,index2)
        if(state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].status==1){
          console.log("set status to 2")
          state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].status=2
        }else{
          console.log("set status to 1")
          state.CanvasGroups[index0].Blocks[index1].TScomponents[index2].status=1
        }

      }else if (payload.length==2) {
        var index0 = clone.findIndex((v) => {
          return v.id==payload[0];
        });
        console.log("index0", index0)
        var index1 = clone[index0].Blocks.findIndex((v) => {
          return v.id==payload[1];
        });
        if(state.CanvasGroups[index0].Blocks[index1].status==1){
          for(let TSc = 0; TSc < clone[index0].Blocks[index1].TScomponents.length; TSc++){
            state.CanvasGroups[index0].Blocks[index1].TScomponents[TSc].status=3
          }
          state.CanvasGroups[index0].Blocks[index1].status=2
        }else if(state.CanvasGroups[index0].Blocks[index1].status==2){
          for(let TSc = 0; TSc < clone[index0].Blocks[index1].TScomponents.length; TSc++){
            state.CanvasGroups[index0].Blocks[index1].TScomponents[TSc].status=1
          }
          state.CanvasGroups[index0].Blocks[index1].status=1
        }


      }





      //state.CanvasGroups=payload
    },
    UpdateCanvasGroupSize (state, payload) {
      console.log("UpdateCanvasGroupSize",payload)
      state.CanvasGroups=payload
    },
    increment (state) {
      state.count++
    },
    updateDateIndex (state,payload) {
      //console.log("updateDateIndex",payload)


      state.DateIndex=payload[0];
      state.years=payload[1];
      state.months=payload[2];
      state.days=payload[3];
      state.MonthIndex=payload[4];

    },
    updateYMD (state,payload) {
      //console.log("updateDateIndex",payload)


      //state.DateIndex=payload[0];
      state.years=payload[0];
      state.months=payload[1];
      state.days=payload[2];
      //state.MonthIndex=payload[4];

    },
    updateAllRowBlocks (state,payload) {
      state.RowBlocks=payload;
    },
    activeedittoggle (state,payload) {
      function arraysEqual(a1,a2) {
        return JSON.stringify(a1)==JSON.stringify(a2);
      }

      //clone store state

      var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

      //find index
      var index = clone1.findIndex((v) => {
        return arraysEqual(v.id,payload);
      });
      state.RowBlocks[index].activeedit=!state.RowBlocks[index].activeedit;
    },
    addBuildingBlock (state,payload) {
      function arraysEqual(a1,a2) {
        return JSON.stringify(a1)==JSON.stringify(a2);
      }

      //clone store state

      var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

      //find index
      var index = clone1.findIndex((v) => {
        return arraysEqual(v.id,payload);
      });
      //state.RowBlocks[index].activeedit=!state.RowBlocks[index].activeedit;
      var currentBuildingBlocks = clone1[index].buildingblocks

      //console.log("currentBuildingBlocks",currentBuildingBlocks)
      var newbuildingblock = {
        rank:3,
        start:5,
        end:70,
        type:1,
        linktype:1,
        params:[0],
        Stochasticparams:[0],
        activeeditsize: 2,
        activeedit: true
      }
      console.log("newbuildingblock",newbuildingblock)
      //var updatedBuildingBlocks = currentBuildingBlocks.push(newbuildingblock)
      currentBuildingBlocks.push(newbuildingblock)
      console.log("updatedBuildingBlocks",currentBuildingBlocks)
      state.RowBlocks[index].buildingblocks.push({
        rank:3,
        start:5,
        end:30,
        type:1,
        linktype:1,
        params:[0],
        Stochasticparams:[0],
        activeeditsize: 1,
        activeedit: true,
        output: [],
        Stochasticoutput:[],
        calcout:[]
      })
      state.outputBlocks[index].buildingblocks.push({
        rank:3,
        start:5,
        end:30,
        type:1,
        linktype:1,
        params:[0],
        Stochasticparams:[0],
        activeeditsize: 1,
        activeedit: true,
        output: [],
        Stochasticoutput:[],
        calcout:[]
      })
      console.log("result",state.RowBlocks[index])

    },
    activeedittoggleBB (state,payload) {
      console.log("activeedittoggleBB store payload",payload)
      function arraysEqual(a1,a2) {
        return JSON.stringify(a1)==JSON.stringify(a2);
      }

      //clone store state

      var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

      //find index
      var index = clone1.findIndex((v) => {
        return arraysEqual(v.id,payload[0]);
      });
      var clone2 = JSON.parse(JSON.stringify(state.RowBlocks[index].buildingblocks));

      //find BB index
      var index2 = clone2.findIndex((v) => {
        return arraysEqual(v.rank,payload[1]);
      });

      state.RowBlocks[index].buildingblocks[index2].activeedit=!state.RowBlocks[index].buildingblocks[index2].activeedit;
    },
    updateBBoutputdata (state,payload) {
      console.log("updateBBoutputdata store payload",payload)
      function arraysEqual(a1,a2) {
        return JSON.stringify(a1)==JSON.stringify(a2);
      }

      //clone store state

      var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

      //find index
      var index = clone1.findIndex((v) => {
        return arraysEqual(v.id,payload[0]);
      });
      var clone2 = JSON.parse(JSON.stringify(state.RowBlocks[index].buildingblocks));

      //find BB index
      var index2 = clone2.findIndex((v) => {
        return arraysEqual(v.rank,payload[1]);
      });

      state.RowBlocks[index].buildingblocks[index2].activeedit=!state.RowBlocks[index].buildingblocks[index2].activeedit;
    },

    BuildOutputBlocks (state,payload) {
      console.log("BuildOutputBlocks",payload)

      var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));
      var outputBlocks = [];

      for(let r=0; r<clone1.length; r++){

        var outputBlock=[{id: clone1[r].id, start:clone1[r].start, end:clone1[r].end, output:[]}]
        var buildingblocks=[];

        for(let b=0; b<clone1[r].buildingblocks.length; b++){
          buildingblocks.push([{
            rank: clone1[r].buildingblocks[b].rank,
            start:clone1[r].buildingblocks[b].start,
            end:clone1[r].buildingblocks[b].end,
            type:clone1[r].buildingblocks[b].type,
            linktype:clone1[r].buildingblocks[b].linktype,
            output:[],
            Stochasticoutput:[],
            calcout:[]

          }][0])
        }
        outputBlock[0].buildingblocks=buildingblocks;
        outputBlocks.push(outputBlock[0])
      }
      state.outputBlocks=outputBlocks
      console.log("outputBlocks",outputBlocks)
    },

    UpdateOutputBlocks (state,payload) {
      console.log("UpdateOutputBlocks. Updating ",payload.length," blocks")
      if(payload=="all"){
        //get all ids and all building blocks
        console.log("payload == all")
        var clone0 = JSON.parse(JSON.stringify(state.RowBlocks));
        var newpayload = [];
        for(let p=0; p<clone0.length; p++){

          for(let bb=0; bb<clone0[p].buildingblocks.length; bb++){
            newpayload.push([clone0[p].id,bb,1])
          }

        }
        console.log("newpayload",newpayload)
        payload=newpayload;

      }

      for(let p=0; p<payload.length; p++){
        console.log("%%%%%%%%%%%%%% start update")

        var updateData=payload[p]
        console.log("updateData",updateData)

        function arraysEqual(a1,a2) {
          return JSON.stringify(a1)==JSON.stringify(a2);
        }

        //clone store state

        var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

        //find index
        var index = clone1.findIndex((v) => {
          return arraysEqual(v.id,updateData[0]);
        });

        var clone2 = JSON.parse(JSON.stringify(state.RowBlocks[index].buildingblocks[updateData[1]]));


        // console.log("I found this",clone2)
        console.log("|\/| | || | || || || | || clone2.type", clone2.type)
        var dataout=[];
        //var Stochasticdataout=[];
        var StochasticdataoutHigh=[];
        var StochasticdataoutMedium=[];
        var StochasticdataoutLow=[];
        var StochasticdataoutHML=[];

        console.log("params",clone2.params)


        if(clone1[index].type==1){
          console.log("clone2.Stochasticparams",clone2.Stochasticparams)
          if(clone2.Stochasticparams[0]){
            console.log("I am a Stochastic Trend block")
            var gaussiandist = gaussian(0,1 )
            // console.log("nnnnnnnnnnnnggggggggggggggggggggggtttttttttttttttttttt------------------gaussiandist",gaussiandist)
            // console.log("gaussiandist.random(1)",gaussiandist.random(1))

            for(let d=0; d<(clone2.end-clone2.start); d++){
              if(d<1){

                dataout.push(1)
                StochasticdataoutHigh.push(1)
                StochasticdataoutMedium.push(1)
                StochasticdataoutLow.push(1)

                //Stochasticdataout.push({high:1,medium:1,low:1})
              }else{

                dataout.push(dataout[d-1]*(1+clone2.params[0]))
                //Stochasticdataout.push(Stochasticdataout[d-1]*(1+clone2.params[0])+gaussiandist.random(1)*1)
                //var stochasttemp = (StochasticdataoutMedium[d-1]*(1+clone2.params[0])+gaussiandist.random(1)*1)

                var stochasttemp = (StochasticdataoutMedium[d-1]*(1+clone2.params[0]))

                // var stochasttempH = JSON.parse(JSON.stringify(stochasttemp))*1.1
                // var stochasttempL = JSON.parse(JSON.stringify(stochasttemp))*.90

                var stochasttempH = (StochasticdataoutHigh[d-1]*(1+clone2.params[0]))+1.96*(1*((d-clone2.start)/20))/100
                var stochasttempL = (StochasticdataoutLow[d-1]*(1+clone2.params[0]))-1.96*(1*((d-clone2.start)/20))/100
                //https://otexts.com/fpp3/prediction-intervals.html



                StochasticdataoutHigh.push(stochasttempH)
                StochasticdataoutMedium.push(stochasttemp)
                StochasticdataoutLow.push(stochasttempL)

                //console.log("stochasttemp",stochasttemp)
                //Stochasticdataout.push({high:stochasttempH,medium:stochasttemp,low:stochasttempL})

              }
              //needs a coverage for end of block levels, to the end of clone1[index].end
            }
            StochasticdataoutHML = [{high:StochasticdataoutHigh,medium:StochasticdataoutMedium, low:StochasticdataoutLow}]
            //console.log("Stochasticdataout",Stochasticdataout)
            console.log("StochasticdataoutHML",StochasticdataoutHML)

          }else{
            console.log("I am not a Stochastic Trend block")

            for(let d=0; d<(clone2.end-clone2.start); d++){
              if(d<1){
                dataout.push(1)

                StochasticdataoutHigh.push(null)
                StochasticdataoutMedium.push(1)
                StochasticdataoutLow.push(null)

              }else{

                dataout.push(dataout[d-1]*(1+clone2.params[0]))
                StochasticdataoutHigh.push(null)
                StochasticdataoutMedium.push(dataout[d-1]*(1+clone2.params[0]))
                StochasticdataoutLow.push(null)

              }
              //needs a coverage for end of block levels, to the end of clone1[index].end
            }
          }




        }
        else if(clone1[index].type==4){

          console.log("|\/| | || | || || || | || I found a Seasonal!")
          function oscillator(time, frequency = 1, amplitude = 1, phase = 0, offset = 0){
              //return Math.sin(time * frequency * Math.PI * 2 + phase * Math.PI * 2) * amplitude + offset;
              var height = 1;
              return (height/2 + amplitude * Math.sin((time+ offset)/frequency));
          }

          var trigseasonal = []
          for(let s=clone2.start; s<(clone2.end-clone2.start); s++){
            //get clone2 params for trig
            trigseasonal.push(oscillator(s,clone2.params[0],clone2.params[1],clone2.params[2],clone2.params[3] ))

            StochasticdataoutHigh.push(oscillator(s,clone2.params[0],clone2.params[1],clone2.params[2],clone2.params[3] )*1)
            StochasticdataoutMedium.push(oscillator(s,clone2.params[0],clone2.params[1],clone2.params[2],clone2.params[3] )*1)
            StochasticdataoutLow.push(oscillator(s,clone2.params[0],clone2.params[1],clone2.params[2],clone2.params[3] )*1)
          }
          console.log("clone2 params:",clone2.params)
          console.log("trigseasonal",trigseasonal,"parms",updateData,"payload",payload)
          console.log("stochastic trig", [{high:StochasticdataoutHigh,medium:StochasticdataoutMedium, low:StochasticdataoutLow}])
          dataout = trigseasonal;

          StochasticdataoutHML = [{high:StochasticdataoutHigh,medium:StochasticdataoutMedium, low:StochasticdataoutLow}]


        }else{

          for(let d=0; d<(clone2.end-clone2.start); d++){
            if(d<1){
              dataout.push(1)
              StochasticdataoutHigh.push(null)
              StochasticdataoutMedium.push(1)
              StochasticdataoutLow.push(null)
            }else{
              dataout.push(dataout[d-1]*(1+clone2.params[0]))
              StochasticdataoutHigh.push(null)
              StochasticdataoutMedium.push(dataout[d-1]*(1+clone2.params[0]))
              StochasticdataoutLow.push(null)

            }
            //needs a coverage for end of block levels, to the end of clone1[index].end
          }
          StochasticdataoutHML = [{high:StochasticdataoutHigh,medium:StochasticdataoutMedium, low:StochasticdataoutLow}]

        }
        //build output

        var calcout = JSON.parse(JSON.stringify(dataout));
        console.log("extension component:",dataout.length, "to", clone1[index].end)
        for(let g=dataout.length; g<clone1[index].end; g++){
          calcout.push(dataout[dataout.length-1])
        }


        console.log("dataout",dataout)
        console.log("updateData",updateData)
        //console.log("updateData",StochasticdataoutHML)

        state.outputBlocks[index].buildingblocks[updateData[1]].calcout=calcout
        state.outputBlocks[index].buildingblocks[updateData[1]].output=dataout
        state.outputBlocks[index].buildingblocks[updateData[1]].Stochasticoutput=StochasticdataoutHML
        state.outputBlocks[index].buildingblocks[updateData[1]].start=clone2.start
        state.outputBlocks[index].buildingblocks[updateData[1]].end=clone2.end
        state.outputBlocks[index].start=clone1[index].start
        state.outputBlocks[index].end=clone1[index].end


        //***************update the group output here
        console.log("@@@@@@@ doing the group output update")
        var clone3 = JSON.parse(JSON.stringify(state.outputBlocks[index]));

        var base = []
        console.log("clone3",clone3.start,clone3.end)
        for(let i=clone3.start; i<=clone3.end; i++){
          base.push(1)
        }
        console.log("starting base", base)

        //for each building block, layer on its output
        for(let bb=0; bb<clone3.buildingblocks.length; bb++){
          console.log("bb",bb)
          var temp=clone3.buildingblocks[bb]
          console.log("temp from clone3!", temp, temp.start,temp.end)
          //basic additive form
          if(temp.calcout.length<1){

          }else{
            for(let t=temp.start; t<(base.length); t++){
              //console.log("t",t)
              if(t>base.length){
                //console.log("no update to base!")
                base[t]=base[t]+(temp.calcout[t-temp.start]-1)

              }else{
                //console.log("update to base!",base[t])

                base[t]=base[t]+(temp.calcout[t-temp.start]-1)
                //console.log("update to base!")
              }
            }

            //fill in end of BB with last calculated value
            if(temp.end<base.length){
              // for(let t2=temp.end; t2<base.length; t2++){
              //   base[t2]=base[temp.end-1]
              // }
            }

          }


        }



        var groupLefts = [];
        var groupRights = [];

        for(let r=0; r<clone3.buildingblocks.length; r++){
          var clone6 = JSON.parse(JSON.stringify(clone3.buildingblocks[r]));

          groupLefts.push(clone6.start)
          groupRights.push(clone6.end)
        }
        console.log("groupLefts",groupLefts,"groupRights",groupRights)

        var gstart = Math.min(...groupLefts)
        var gend = Math.max(...groupRights)

        console.log("gstart",gstart,"gend",gend)
        //var base = []
        var base2 = []
        var base3 = []
        var baseHigh = []
        var baseLow = []
        var baseMedium = []

        var DateIndexclone = JSON.parse(JSON.stringify(state.DateIndex));

        //console.log("clone3",clone3.start,clone3.end)

        for(let i=gstart; i<=clone3.end; i++){

          //base.push(1)
          base2.push([DateIndexclone[i],1])
          base3.push([DateIndexclone[i],1])
          baseHigh.push([DateIndexclone[i],1])
          baseMedium.push([DateIndexclone[i],1])
          baseLow.push([DateIndexclone[i],1])
        }
        // baseHigh = base3
        // baseLow = base3
        // baseMedium = base3
        console.log("base2", base2)
        console.log("baseMedium", baseMedium)

        var clone4 = clone3.buildingblocks;


        for(let r=0; r<clone4.length; r++){
          var temp=JSON.parse(JSON.stringify(clone4[r]));

          // var StochMed = JSON.parse(JSON.stringify(temp.Stochasticoutput.medium))
          // console.log("StochMed",StochMed)
          console.log("looking for length in temp.Stochasticoutput",temp.Stochasticoutput)
          //console.log("temp.Stochasticoutput.medium",temp.Stochasticoutput.medium)
          // if(temp.Stochasticoutput.medium.length>0){
          // // console.log("temp.Stochasticoutput.medium[20]",temp.Stochasticoutput.medium)
          // }
          for(let t=temp.start; t<temp.end; t++){
            //console.log("t",t)
            if(t>=base2.length){
              //console.log("no update to base!")
              //base[t]=base[t]+(temp.output[t-temp.start]-1)

            }else{
              //console.log("update to base!",base[t])

              //base[t]=base[t]+(temp.output[t-temp.start]-1)
              base2[t][1]=base2[t][1]+(temp.output[t-temp.start]-1)
              //base3[t][1]=base3[t][1]+(temp.Stochasticoutput[t-temp.start]-1)

              if(temp.Stochasticoutput.length>0){
                //console.log("temp.Stochasticdataout.medium",temp.Stochasticoutput.medium)
                baseMedium[t][1]=baseMedium[t][1]+(temp.Stochasticoutput[0].medium[t-temp.start]-1)

                if((temp.Stochasticoutput[0].high[t-temp.start])==null){
                  baseHigh[t][1]=baseHigh[t][1]
                }else{
                  baseHigh[t][1]=baseHigh[t][1]+(temp.Stochasticoutput[0].high[t-temp.start]-1)
                }
                if((temp.Stochasticoutput[0].low[t-temp.start])==null){
                  baseLow[t][1]=baseLow[t][1]
                }else{
                  baseLow[t][1]=baseLow[t][1]+(temp.Stochasticoutput[0].low[t-temp.start]-1)

                }
              }




              //console.log("update to base!")
            }
          }

        }


        console.log("output from base", base2)
        //
        // console.log("output from baseMedium", baseMedium)
        // console.log("output from baseHigh", baseHigh)

        // console.log("index", index)
        // console.log("id",updateData[0])
        // console.log("clone1",clone1)
        state.outputBlocks[index].output=base2;
        state.outputBlocks[index].Stochasticoutput=[{high:baseHigh,medium:baseMedium, low:baseLow}];

        console.log("%%%%%%%%%%%%%% end")

      }

    },

    UpdateBuildingBlocks (state,payload) {
      console.log("UpdateBuildingBlocks. Updating ",payload.length," blocks")

      for(let p=0; p<payload.length; p++){

        var updateData=payload[p]
        console.log("updateData",updateData)
        // console.log("id:",updateData[0])
        // console.log("bb id:",updateData[1])
        // console.log("params:",updateData[2])


        function arraysEqual(a1,a2) {
          return JSON.stringify(a1)==JSON.stringify(a2);
        }

        //clone store state

        var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

        //find index
        var index = clone1.findIndex((v) => {
          return arraysEqual(v.id,updateData[0]);
        });


        if(updateData.length>3){
          console.log("updating activeeditsize")
          state.RowBlocks[index].buildingblocks[updateData[1]].activeeditsize=updateData[3]
        }else{
          //state.RowBlocks[index].buildingblocks[updateData[1]].params=updateData[2]

        }
        //need to trigger update of output blocks with new information

        //UpdateOutputBlocks (state,payload)


      }

    },
    UpdateBuildingBlocksParams (state,payload) {
      console.log("UpdateBuildingBlocksParams. Updating ",payload.length," blocks")

      for(let p=0; p<payload.length; p++){

        var updateData=payload[p]
        console.log("updateData",updateData)



        function arraysEqual(a1,a2) {
          return JSON.stringify(a1)==JSON.stringify(a2);
        }

        //clone store state

        var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

        //find index
        var index = clone1.findIndex((v) => {
          return arraysEqual(v.id,updateData[0]);
        });

        var newparams = []
        for(let s=2; s<updateData.length; s++){
          newparams.push(updateData[s])
        }

          state.RowBlocks[index].buildingblocks[updateData[1]].params=newparams

      }

    },
    UpdateBuildingBlocksStochasticParams (state,payload) {
      console.log("UpdateBuildingBlocksStochasticParams. Updating ",payload.length," blocks")

      for(let p=0; p<payload.length; p++){

        var updateData=payload[p]
        console.log("updateData",updateData)



        function arraysEqual(a1,a2) {
          return JSON.stringify(a1)==JSON.stringify(a2);
        }

        //clone store state

        var clone1 = JSON.parse(JSON.stringify(state.RowBlocks));

        //find index
        var index = clone1.findIndex((v) => {
          return arraysEqual(v.id,updateData[0]);
        });

        var newparams = []
        for(let s=2; s<updateData.length; s++){
          newparams.push(updateData[s])
        }

          state.RowBlocks[index].buildingblocks[updateData[1]].Stochasticparams=newparams[0]

      }

    },
    UpdateTimelineSubGroups (state,payload) {
      console.log("UpdateTimelineSubGroups start")
      //clone store state
      var DateIndexclone = JSON.parse(JSON.stringify(state.DateIndex));
      var clone0 = JSON.parse(JSON.stringify(state.outputBlocks));
      var cloneTSG = JSON.parse(JSON.stringify(state.TimelineSubGroups));

      if(payload=="all"){

      var TSGids = []

      for(let s=0; s<cloneTSG.length; s++){
        TSGids.push(cloneTSG[s].id)
      }

      }else{
        TSGids=payload
      }


      for(let sg=0; sg<cloneTSG.length; sg++){

        if(TSGids.includes(cloneTSG[sg].id)){

          // TSGids.push(cloneTSG[t].id)
          var RowBlockSubReturn = []

          for(let c=0; c<clone0.length; c++){
            //var cid=clone0[c].id
            if(clone0[c].id[0]==cloneTSG[sg].id){
              RowBlockSubReturn.push(clone0[c])
            }
          }

          var clone1 = JSON.parse(JSON.stringify(RowBlockSubReturn));

          var groupLefts = [];
          var groupRights = [];

          for(let r=0; r<clone1.length; r++){
            var clone2 = JSON.parse(JSON.stringify(clone1[r]));

            groupLefts.push(clone2.start)
            groupRights.push(clone2.end)
          }

          var gstart = Math.min(...groupLefts)
          var gend = Math.max(...groupRights)

          //var base = []
          var base2 = []
          var baseHigh = []
          var baseLow = []
          var baseMedium = []
          //console.log("clone3",clone3.start,clone3.end)
          for(let i=gstart; i<=gend; i++){
            //base.push(1)
            base2.push([DateIndexclone[i],1])
            baseHigh.push([DateIndexclone[i],1])
            baseMedium.push([DateIndexclone[i],1])
            baseLow.push([DateIndexclone[i],1])
          }
          //console.log("starting base", base)

          for(let r=0; r<clone1.length; r++){
            var temp=clone1[r]
            console.log("this is temp", temp)
            for(let t=temp.start; t<temp.end; t++){
              //console.log("t",t)
              var rt = JSON.parse(JSON.stringify(t-temp.start))
              //console.log("rt", rt)
              if(t>=temp.Stochasticoutput[0].medium.length){
                //console.log("no update to base!")
                //base[t]=base[t]+(temp.output[t-temp.start]-1)

              }else{
                //console.log("update to base!",base[t])

                //base[t]=base[t]+(temp.output[t-temp.start]-1)
                base2[t][1]=base2[t][1]+(temp.output[t-temp.start]-1)

                if(temp.Stochasticoutput.length>0){
                  //console.log("TLSG %%%%% temp.Stochasticdataout.medium @",t-temp.start,temp.Stochasticoutput[0].medium[t-temp.start])
                  baseMedium[t][1]=baseMedium[t][1]+(temp.Stochasticoutput[0].medium[rt][1]-1)

                  if((temp.Stochasticoutput[0].high[t-temp.start])==null){
                    baseHigh[t][1]=baseHigh[t][1]
                  }else{
                    baseHigh[t][1]=baseHigh[t][1]+(temp.Stochasticoutput[0].high[rt][1]-1)
                  }
                  if((temp.Stochasticoutput[0].low[t-temp.start])==null){
                    baseLow[t][1]=baseLow[t][1]
                  }else{
                    baseLow[t][1]=baseLow[t][1]+(temp.Stochasticoutput[0].low[rt][1]-1)

                  }
                }
                //console.log("update to base!")
              }
            }

          }
          state.TimelineSubGroups[sg].output=base2
          state.TimelineSubGroups[sg].Stochasticoutput=[{high:baseHigh,medium:baseMedium, low:baseLow}];

          state.TimelineSubGroups[sg].start=gstart
          state.TimelineSubGroups[sg].end=gend

          console.log("state.TimelineSubGroups[sg].Stochasticoutput",state.TimelineSubGroups[sg].Stochasticoutput)

        }

      }
      console.log("UpdateTimelineSubGroups end")
      console.log("output check",state.TimelineSubGroups)

    },
    UpdateTimelineGroups (state,payload) {
      console.log("UpdateTimelineGroups start")
      //clone store state
      var DateIndexclone = JSON.parse(JSON.stringify(state.DateIndex));
      var clone0 = JSON.parse(JSON.stringify(state.TimelineSubGroups));
      var cloneTG = JSON.parse(JSON.stringify(state.TimelineGroups));

      if(payload=="all"){

      var TGids = []

      for(let s=0; s<cloneTG.length; s++){
        TGids.push(cloneTG[s].id)
      }

      }else{
        TGids=payload
      }


      for(let sg=0; sg<cloneTG.length; sg++){

        if(TGids.includes(cloneTG[sg].id)){

          // TSGids.push(cloneTSG[t].id)
          var RowBlockSubReturn = []

          for(let c=0; c<clone0.length; c++){
            //var cid=clone0[c].id
            if(cloneTG[sg].subGroups.includes(clone0[c].id)){
              RowBlockSubReturn.push(clone0[c])
            }
          }

          var clone1 = JSON.parse(JSON.stringify(RowBlockSubReturn));

          var groupLefts = [];
          var groupRights = [];

          for(let r=0; r<clone1.length; r++){
            var clone2 = JSON.parse(JSON.stringify(clone1[r]));

            groupLefts.push(clone2.start)
            groupRights.push(clone2.end)
          }

          var gstart = Math.min(...groupLefts)
          var gend = Math.max(...groupRights)

          //var base = []
          var base2 = []
          var baseHigh = []
          var baseLow = []
          var baseMedium = []

          //console.log("clone3",clone3.start,clone3.end)
          for(let i=gstart; i<=gend; i++){
            //base.push(1)
            base2.push([DateIndexclone[i],1])
            baseHigh.push([DateIndexclone[i],1])
            baseMedium.push([DateIndexclone[i],1])
            baseLow.push([DateIndexclone[i],1])
          }
          //console.log("starting base", base)

          for(let r=0; r<clone1.length; r++){
            var temp=clone1[r]

            for(let t=temp.start; t<temp.end; t++){
              //console.log("t",t)
              var rt = JSON.parse(JSON.stringify(t-temp.start))

              if(t>=temp.Stochasticoutput[0].medium.length){
                //console.log("no update to base!")
                //base[t]=base[t]+(temp.output[t-temp.start]-1)

              }else{
                //console.log("update to base!",base[t])

                //base[t]=base[t]+(temp.output[t-temp.start]-1)
                base2[t][1]=base2[t][1]+(temp.output[t-temp.start]-1)

                if(temp.Stochasticoutput.length>0){
                  //console.log("TLSG %%%%% temp.Stochasticdataout.medium @",t-temp.start,temp.Stochasticoutput[0].medium[t-temp.start])
                  baseMedium[t][1]=baseMedium[t][1]+(temp.Stochasticoutput[0].medium[rt][1]-1)

                  if((temp.Stochasticoutput[0].high[t-temp.start])==null){
                    baseHigh[t][1]=baseHigh[t][1]
                  }else{
                    baseHigh[t][1]=baseHigh[t][1]+(temp.Stochasticoutput[0].high[rt][1]-1)
                  }
                  if((temp.Stochasticoutput[0].low[t-temp.start])==null){
                    baseLow[t][1]=baseLow[t][1]
                  }else{
                    baseLow[t][1]=baseLow[t][1]+(temp.Stochasticoutput[0].low[rt][1]-1)

                  }
                }

              }
            }

          }
          state.TimelineGroups[sg].output=base2
          state.TimelineGroups[sg].Stochasticoutput=[{high:baseHigh,medium:baseMedium, low:baseLow}];

          state.TimelineGroups[sg].start=gstart
          state.TimelineGroups[sg].end=gend

        }

      }
      console.log("UpdateTimelineGroups end")
      console.log("output check",state.TimelineGroups)

    },
    NewTimelineGroup (state,payload) {
      console.log("NewTimelineGroup Payload", payload)
      var payloadt =JSON.parse(JSON.stringify(payload))
      var newTLGroup = payloadt[0]
      //check for id clearence
      var ids = [];
      for(let i=0; i<state.TimelineGroups.length; i++){
        ids.push(state.TimelineGroups[i].id)
      }
      newTLGroup.id=Math.max(...ids)+1
      newTLGroup.subGroups=payloadt[1]

      console.log("newTLGroup", newTLGroup)
      state.TimelineGroups.push(newTLGroup)
    },
    NewTimelineSubGroup (state,payload) {
      console.log("NewTimelineSubGroup Payload", payload)
      var payloadt =JSON.parse(JSON.stringify(payload))
      var newTLSGroup = payloadt[0]
      //check for id clearence
      var ids = [];
      for(let i=0; i<state.TimelineSubGroups.length; i++){
        ids.push(state.TimelineSubGroups[i].id)
      }
      newTLSGroup.id=Math.max(...ids)+1
      //newTLGroup.subGroups=payloadt[1]

      var newRowBlock ={
          id: [newTLSGroup.id,1,1,1,1,1],
          name: 'Super Block',
          rank:0,
          start:1,
          end:75,
          type:1,
          data:[
            {x:1,y:4},
            {x:2,y:3},
            {x:3,y:9}

          ],
          chartdata:[1,2,3],
          activeedit: true,
          buildingblocks:[{
            rank:1,
            start:5,
            end:70,
            type:1,
            linktype:1,
            params:[0],
            Stochasticparams:[0],
            activeeditsize: 1,
            activeedit: true
          }]
        }

      console.log("newTLSubGroup", newTLSGroup)
      state.TimelineSubGroups.push(newTLSGroup)
      state.RowBlocks.push(newRowBlock)
    },
    newRowBlock (state,payload) {
      console.log("newRowBlock Payload", payload)
      var payloadt =JSON.parse(JSON.stringify(payload))

      state.RowBlocks.push(payloadt)
    },
    setCurrentScenario (state, payload) {
      state.CurrentScenario=payload
    },
    setScenarioSetSettings(state, payload) {
      console.log("setScenarioSetSettings in store",payload)

      var clone = state.ScenarioSets
      console.log("clone",clone)
      var index = clone.findIndex((v) => {
        console.log("v",v)
        return v.id[0]==payload[0].id[0];
      });

      console.log("clone[index].sets",clone[index].sets)
      var index2 = clone[index].sets.findIndex((v) => {
        return v.id==payload[1].id;
      });

      console.log("index2", index2)

      //clone[index].sets[index2]<-payload[1]

      state.ScenarioSets[index].sets[index2]<-payload[1]
    },

    ComputedCanvasGroup(state,payload) {
      console.log("got inside ComputedCanvasGroup in store",payload)

      var CanvasGroupsToCombine = payload[0].CanvasGroups
      var CGsclone = state.CanvasGroups
      var methods = payload[0].methods

      var BaseCG = [];

      for(let cg=0; cg<CanvasGroupsToCombine.length; cg++){
        console.log("CanvasGroupsToCombine cg",cg,"in",CanvasGroupsToCombine)
        var index0 = CGsclone.findIndex((v) => {
          return v.id==CanvasGroupsToCombine[cg];
        });


        console.log("index0",index0)

        if(cg==0){

          //establish the Canvas Group that will serve as the Computed base
          BaseCG = CGsclone[index0]
          console.log("BaseCG.output",BaseCG.output)

        }else{
          //update the output of the Base Canvas group
          // console.log("BaseCG.output",BaseCG.output)
          // console.log("CGsclone[index0].output",CGsclone[index0].output)
          // console.log("methods[cg]",methods)
          // console.log("payload[1]",payload[1])

          //BaseCG.output=combineTimeSeries([BaseCG.output,CGsclone[index0].output],methods,payload[1],state)

        }

      }

      console.log("BaseCG",BaseCG)
      return BaseCG;

    },


    UpdateCanvasGroups(state,payload) {
      console.log("UpdateCanvasGroups payload",payload)
      var idin = payload[0]
      var paramsin = payload[1]
      var CGsclone = state.CanvasGroups

      //find the Canvas group
      var index = CGsclone.findIndex((v) => {
        return arraysEqual(idin,v.id)
      });



      function treeTraverse(tree){

        console.log("tree",tree.name)
        if(tree.hasOwnProperty("children")){
          console.log("tree has children")

          var childoutputs = []

          for(let c=0; c<tree.children.length; c++){
            console.log("tree.children[c]",tree.name,tree.children[c].name)
            var coutput = treeTraverse(tree.children[c])
            console.log("coutput",c,tree.children[c].name,tree.children[c].output,coutput)
            childoutputs.push(coutput)
          }

          //need to sum the child outputs properly
          console.log("childoutputs",tree.name,childoutputs,tree.children)
          var methods = []
          //console.log(tree.name,"going to call combineTimeSeries with",childoutputs,methods,payload[0],state)
          tree.output = combineTimeSeries(childoutputs,methods,payload[0],state)
          //console.log("combineTimeSeries",tree.output)

          //console.log("tree output",tree.output)
          return tree.output


        }else{
          console.log("end of tree limb",tree.output)
          return tree.output
        }

      }
      for(let c=0; c<CGsclone.length; c++){
        console.log("treeTraverse",treeTraverse(CGsclone[c]))


        //state.CanvasGroups[c].output=treeTraverse(CGsclone[c]
      }
    },
    chartToggle(state,payload){
      state.showCharts=payload[0]
    }



  },
  getters: {
    getCanvasGroups: state => {
        return state.CanvasGroups;
    }
  },
  actions: {

    ComputedCanvasGroup (context, payload) {
      context.commit('ComputedCanvasGroup',payload)
    },
    setScenarioSetSettings (context,payload) {
      context.commit('setScenarioSetSettings',payload)
    },
    SetActiveCanvasBlock (setScenarioSetSettings,payload) {
      context.commit("SetActiveCanvasBlock",payload)
    },
    UpdateACanvasDateRange (context,payload) {
      context.commit("UpdateACanvasDateRange",payload)
    },
    UpdatecolWidth (context,payload) {
      context.commit("UpdatecolWidth",payload)
    },
    BuildActiveTree (context,payload) {
      context.commit('BuildActiveTree',payload)
    },
    DeactivateAllOtherVDRInstances (context,payload) {
      context.commit('DeactivateAllOtherVDRInstances',payload)
    },
    DeactivateCanvasGroupElement (context,payload) {
      context.commit('DeactivateCanvasGroupElement',payload)
    },
    UpdateCanvasGroupActiveLevels (context,payload) {
      context.commit('UpdateCanvasGroupActiveLevels',payload)
    },
    UpdateCanvasGroupSize (context,payload) {
      context.commit('UpdateCanvasGroupSize',payload)
    },
    UpdateOmniBlockDimensions(context,payload) {
      context.commit('UpdateOmniBlockDimensions',payload)
    },
    AddChildBlock (context,payload) {
      context.commit('AddChildBlock',payload)
    },
    UpdateCanvasGroupParam (context,payload){
      context.commit('UpdateCanvasGroupParam',payload)
    },
    UpdateCanvasGroupCoreLinks (context,payload){
      context.commit('UpdateCanvasGroupCoreLinks',payload)
    },
    VDRpreventActiveBehavior (context,payload){
      context.commit('VDRpreventActiveBehavior',payload)

    },
    ExpandOmniBlock (context,payload) {
      context.commit('ExpandOmniBlock',payload)

    },
    UpdateCanvasGroup (context,payload) {
      context.commit('UpdateCanvasGroup',payload)
    },
    increment (context,payload) {
      context.commit('increment')
    },
    updateDateIndex (context,payload) {
      context.commit('updateDateIndex',payload)
    },
    updateYMD (context,payload) {
      context.commit('updateYMD',payload)
    },
    updateAllRowBlocks (context,payload) {
      context.commit('updateAllRowBlocks',payload)
    },
    UpdateBuildingBlocks (context,payload) {
      context.commit('UpdateBuildingBlocks',payload)
      //context.commit('UpdateOutputBlocks',payload)

    },
    UpdateBuildingBlocksParams (context,payload) {
      context.commit('UpdateBuildingBlocksParams',payload)
      //context.commit('UpdateOutputBlocks',payload)

    },
    UpdateBuildingBlocksStochasticParams (context,payload) {
      context.commit('UpdateBuildingBlocksStochasticParams',payload)
      //context.commit('UpdateOutputBlocks',payload)

    },
    addBuildingBlock (context,payload) {
      context.commit('addBuildingBlock',payload)
      //context.commit('UpdateOutputBlocks',payload)

    },
    activeedittoggle (context,payload) {
      context.commit('activeedittoggle',payload)
    },
    activeedittoggleBB (context,payload) {
      context.commit('activeedittoggleBB',payload)
    },
    updateBBoutputdata (context,payload) {
      context.commit('updateBBoutputdata',payload)
    },
    BuildOutputBlocks (context,payload) {
      context.commit('BuildOutputBlocks',payload)
    },
    UpdateOutputBlocks (context,payload) {

      context.commit('UpdateOutputBlocks',payload)
      context.commit('UpdateTimelineSubGroups',"all")
      context.commit('UpdateTimelineGroups',"all")

    },
    UpdateTimelineSubGroups (context,payload) {
      context.commit('UpdateTimelineSubGroups',payload)
    },
    NewTimelineGroup (context,payload) {
      context.commit('NewTimelineGroup',payload)
    },
    NewTimelineSubGroup (context,payload) {
      context.commit('NewTimelineSubGroup',payload)
      context.commit('UpdateTimelineSubGroups',"all")

    },
    newRowBlock (context,payload) {
      context.commit('newRowBlock',payload)
    },
    setCurrentScenario (context,payload) {
      context.commit('setCurrentScenario',payload)
    },
    UpdateCanvasGroups (context,payload) {
      context.commit('UpdateCanvasGroups',payload)
    },
    chartToggle (context, payload) {
      context.commit('chartToggle',payload)
    }

  }
})
